import { render, staticRenderFns } from "./EditBirthdayField.vue?vue&type=template&id=ebebccb8&"
import script from "./EditBirthdayField.vue?vue&type=script&lang=ts&"
export * from "./EditBirthdayField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports